export default {"src":"/_next/static/media/join-discord-v3.6633f4f3.svg","height":50,"width":135,"blurWidth":0,"blurHeight":0};